import { gql } from "@apollo/client";

export const UPDATE_SERVICE_REQUEST = gql`
  mutation UpdateServiceRequest($serviceRequest: UpdateServiceRequestInput!) {
    updateServiceRequest(serviceRequest: $serviceRequest) {
      id
      status
      additionalDetails {
        questionId
        question
        answer
        answerType
        options
        selectedOptions
        files
        isMandatory
      }
      updatedAt
    }
  }
`;










